import React, { useEffect, useMemo } from 'react'
import T from 'prop-types'
import { Box } from '@mui/material'
import {
  ASSIGNMENT_STATE_TEAM_OK,
  ASSIGNMENT_STATE_TEAM_OK_NR,
} from 'lib/assignmentStates'

import CarDetails from '../CarDetails'
import CarDetailsPageTitle from '../CarDetails/CarDetailsPageTitle'
import AssignmentCarAdditionalDetails from '../Assignment/AssignmentCarAdditionalDetails'
import useAssignmentCarChoice from '../Assignment/useAssignmentCarChoice'
import { getAssignmentState } from '../Assignment/assignmentLib'

import AssignmentCarTable from './AssignmentCarTable'

export default function AssignmentCarDetails({
  vin,
  session,
  readOnly,
  setShowDetails,
  cars,
  partners,
  refetchList,
  contentIsReadOnly,
}) {
  const { isUpdating, fetchCarChoice, assignCar, carChoice } =
    useAssignmentCarChoice()

  useEffect(() => {
    if (!vin) {
      return
    }

    fetchCarChoice(session?.sessionId, vin)
  }, [fetchCarChoice, vin, session?.sessionId])

  const car = useMemo(
    () => carChoice?.assignments?.find((car) => car.vin === vin),
    [carChoice.assignments, vin]
  )

  const handleAssignCarChoice = async (partnerId, price, fee) => {
    await assignCar(session.sessionId, vin, partnerId, price, fee)
    await refetchList()
  }

  return (
    <div data-testid="car-details-container">
      <CarDetailsPageTitle
        setShowDetails={setShowDetails}
        cars={cars}
        vin={vin}
      />
      {car && (
        <CarDetails
          car={car}
          fee={car.assignmentFee || car.fee}
          price={
            [ASSIGNMENT_STATE_TEAM_OK_NR, ASSIGNMENT_STATE_TEAM_OK].includes(
              getAssignmentState(car)
            ) && car?.finalPrice
          }
          isAssignement
          center={
            <>
              <AssignmentCarTable
                session={session}
                carChoice={carChoice}
                handleAssignTo={handleAssignCarChoice}
                isUpdating={isUpdating}
                readOnly={
                  !!session?.assignmentEndedAt || readOnly || contentIsReadOnly
                }
              />
              <Box pb={2} />
            </>
          }
          rightBottom={
            <>
              <AssignmentCarAdditionalDetails
                vertical
                car={car}
                partners={partners}
                sessionState={session.agenda.assignment.state}
              />
            </>
          }
        />
      )}
    </div>
  )
}

AssignmentCarDetails.propTypes = {
  vin: T.string.isRequired,
  session: T.object.isRequired,
  carChoice: T.object,
  assignCar: T.func,
  partners: T.array,
  isUpdating: T.bool,
  readOnly: T.bool,
}
